import { render, staticRenderFns } from "./consistentResult.vue?vue&type=template&id=94f6fbec&scoped=true&"
import script from "./consistentResult.vue?vue&type=script&lang=js&"
export * from "./consistentResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f6fbec",
  null
  
)

export default component.exports